module.exports = __webpack_public_path__ + "img/icon_test_free.67c597f7.png";